export default __webpack_public_path__ + "static/media/logo2_no_bg.88c0a0e6.png";